import { render, staticRenderFns } from "./ReportTextQualitySettings.vue?vue&type=template&id=090d6bd8&"
import script from "./ReportTextQualitySettings.vue?vue&type=script&lang=js&"
export * from "./ReportTextQualitySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports